import { render, staticRenderFns } from "./ForgotPasswordStep2.vue?vue&type=template&id=66d357a8&"
import script from "./ForgotPasswordStep2.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordStep2.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordStep2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports